import { getName, getNames, registerLocale } from 'i18n-iso-countries/index.js';
import deLocale from 'i18n-iso-countries/langs/de.json';
import enLocale from 'i18n-iso-countries/langs/en.json';
import esLocale from 'i18n-iso-countries/langs/es.json';
import frLocale from 'i18n-iso-countries/langs/fr.json';
import hiLocale from 'i18n-iso-countries/langs/hi.json';
import idLocale from 'i18n-iso-countries/langs/id.json';
import itLocale from 'i18n-iso-countries/langs/it.json';
import jaLocale from 'i18n-iso-countries/langs/ja.json';
import koLocale from 'i18n-iso-countries/langs/ko.json';
import ptLocale from 'i18n-iso-countries/langs/pt.json';
import ruLocale from 'i18n-iso-countries/langs/ru.json';
import thLocale from 'i18n-iso-countries/langs/th.json';
import trLocale from 'i18n-iso-countries/langs/tr.json';
import zhLocale from 'i18n-iso-countries/langs/zh.json';

import { Lang } from '../app.routes-config';

for (const locale of [
  deLocale,
  enLocale,
  esLocale,
  frLocale,
  hiLocale,
  idLocale,
  itLocale,
  jaLocale,
  koLocale,
  ptLocale,
  ruLocale,
  thLocale,
  trLocale,
  zhLocale,
]) {
  registerLocale(locale);
}

const ISO_COUNTRIES_LANG_BY_LANG: Partial<Record<Lang, string>> = { 'es-419': 'es', 'pt-br': 'pt', 'zh-tw': 'zh' };

const EXCLUDED_COUNTRY_CODES: readonly string[] = ['CN', 'CU', 'IR', 'KP', 'SY'];

export const ALL_COUNTRY_CODES: readonly string[] = Object.keys(getNames('fr', { select: 'official' })).filter(
  (code) => !EXCLUDED_COUNTRY_CODES.includes(code),
);

export const countryLabel = (code: string, lang: Lang): string =>
  getName(code, ISO_COUNTRIES_LANG_BY_LANG[lang] ?? lang, { select: 'official' }) ?? code;

export interface CountryOption {
  code: string;
  label: string;
}

export const buildCountryOptions = (lang: Lang): CountryOption[] =>
  ALL_COUNTRY_CODES.map((code) => ({ code, label: countryLabel(code, lang) })).sort((first, second) =>
    first.label.localeCompare(second.label, lang),
  );
